const departments = [
    { name: "Engineering", count: 86, percentage: 40.2, color: "#6FC49A" },
    { name: "Product", count: 32, percentage: 15.0, color: "#F5B53F" },
    { name: "Growth", count: 25, percentage: 11.7, color: "#FF7D6B" },
    { name: "Customer", count: 38, percentage: 17.8, color: "#5A8DEE" },
    { name: "Business Ops", count: 21, percentage: 9.8, color: "#F39C12" },
    { name: "Data & Analytics", count: 12, percentage: 5.6, color: "#4BC0C0" },
  ];
  
  export default function DepartmentDistribution() {
    let accumulatedPercentage = 0;
    const gradientStops = departments
      .map((dept) => {
        const start = accumulatedPercentage;
        accumulatedPercentage += dept.percentage;
        return `${dept.color} ${start}% ${accumulatedPercentage}%`;
      })
      .join(", ");
  
    const totalEmployees = departments.reduce((acc, curr) => acc + curr.count, 0);
  
    return (
      <div className="bg-white rounded-xl shadow-sm p-3 w-full max-w-md">
        {/* Header */}
        <div className="mb-2">
          <h3 className="text-sm font-semibold text-slate-700">
            Department Distribution
          </h3>
        </div>
  
        {/* Main Content */}
        <div className="flex items-center justify-between gap-4">
          
          {/* Donut Chart */}
          <div className="relative shrink-0">
            <div
              className="w-36 h-36 rounded-full"
              style={{
                background: `conic-gradient(${gradientStops})`,
              }}
            />
  
            {/* Center Hole */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-20 h-20 rounded-full bg-white flex flex-col items-center justify-center shadow-xs">
                <h3 className="text-lg font-bold text-slate-800 leading-none">
                  {totalEmployees}
                </h3>
                <p className="text-[10px] text-slate-500 mt-0.5">Employees</p>
              </div>
            </div>
          </div>
  
          {/* Compact List Details */}
          <div className="flex-1 min-w-0 flex flex-col justify-center">
            {departments.map((dept) => (
              <div
                key={dept.name}
                className="flex items-center justify-between text-xs py-0.5 leading-tight"
              >
                <div className="flex items-center gap-1.5 min-w-0 pr-1">
                  <span
                    className="w-2 h-2 rounded-full shrink-0"
                    style={{ backgroundColor: dept.color }}
                  />
                  <span className="text-slate-700 truncate font-medium">
                    {dept.name}
                  </span>
                </div>
  
                <span className="text-slate-600 shrink-0 font-medium tabular-nums text-[11px]">
                  {dept.count} <span className="text-slate-400">({dept.percentage}%)</span>
                </span>
              </div>
            ))}
          </div>
        </div>
  
        {/* Insight Banner */}
        <div className="mt-2.5 text-xs bg-slate-50 border border-slate-200 rounded-md p-1.5 text-slate-700">
          ⭐ Engineering leads at <strong>86 (40.2%)</strong>
        </div>
      </div>
    );
  }